<div class="register-leave-combined">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'Accept Leave' | translate: ['tmc.transport.register.leave.combined.title', translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
        [driver]="transport.name" [scope]="transport.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <div class="grid">

        <div class="form-box" style="grid-column: 1 / span 2; grid-row: 1;">
          <h3>{{'Spur' | translate: ['tmc.transport.register.leave.area-gate.title',
            translationService.language]}}</h3>
          <mat-form-field >
            <mat-select [(value)]="selectedAreaGate">
                <mat-option *ngFor="let gate of areaGates" [value]="gate">
                    {{ gate.name }}
                </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-box" style="grid-column: 1; grid-row: 2;">
          <h3>{{'supplementary equipment' | translate:
            ['tmc.transport.register.leave.combined.supplementaryequipment.title', translationService.language]}}
          </h3>
          <div class="se-grid" *ngIf="supplementaryEquipmendHandouted(seTransport)">
            <ng-container *ngFor="let se of seTransport.supplementaryEquipments; let i = index">
              <div class="center" style="grid-column: 1;" [ngStyle]="{'grid-row': i + 1 }">
                <mat-checkbox [(ngModel)]="se.selected" [ngModelOptions]="{standalone: true}"
                  [disabled]="isFormReadonly()" name="{{i}}" (change)="selected(se, $event)">
                  {{se.dictionaryKey | translate:[se.dictionaryKey, translationService.language]}}</mat-checkbox>
              </div>
              <mat-form-field style="grid-column: 2;" [ngStyle]="{'grid-row': i + 1}" *ngIf="isParam1Available(se)">
                <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}" required
                  [readonly]="true"
                  placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
              </mat-form-field>
            </ng-container>
          </div>
          <div *ngIf="!supplementaryEquipmendHandouted(seTransport)">
            {{'Begleitmittel' | translate:
            ['tmc.transport.register.leave.combined.label.nosupplementaryequipmenthandout',
            translationService.language]}}
          </div>
        </div>

        <form #weighForm="ngForm" class="weigh-input-form" *ngIf="isWeighingActive()"
          style="grid-column: 2; grid-row: 2;">
          <div class="form-box">
            <h3>{{'weigh transport' | translate: ['tmc.transport.register.leave.combined.weighing.title',
              translationService.language]}}</h3>
            <div class="flex-direction-row row-flex">
              <mat-form-field class="flex-grow-1">
                <input name="value" matInput [(ngModel)]="transport.weight" #ctrlValue="ngModel" type="number" min="0"
                  placeholder="{{'weight' | translate: ['tmc.transport.register.leave.combined.weight', translationService.language]}}"
                  [readonly]="isFormReadonly()"
                  [required]="configurationService.isRequired(clientParameters.P_VISITOVERVIEW_REGISTER_ENTRANCE_MINLENGHT_WEIGHT, false)"
                  appPositiveInteger>
                <mat-error *ngIf="showValuePositiveIntegerError(ctrlValue)">
                  {{'value must positive and Integer' | translate: ['tmc.weigh-transport-dialog.error.value-no-integer',
                  translationService.language]}}
                </mat-error>
              </mat-form-field>
              <button mat-icon-button type="button" class="weighingButton" (click)="readWeight()"
                [hidden]="isAutoWeighingVisible()"
                [matTooltip]="'Weigh Transport' | translate: ['tmc.visit.overview.action.weighTransport', translationService.language]"
                *ngIf="configurationService.isEnabled(clientParameters.P_VISITS_WEIGHING_ENABLED, false)">
                <sc-icon iconClass="fa-balance-scale"></sc-icon>
              </button>
              <mat-form-field class="margin-left">
                <mat-label>
                  {{'type' | translate: ['tmc.transport.register.leave.combined.weighingType',
                  translationService.language]}}
                </mat-label>
                <mat-select name="type" [(ngModel)]="transport.weighingType" #ctrlType="ngModel"
                  [required]="isWeighingTypeRequired()" [disabled]="isFormReadonly()">
                  <mat-option *ngFor="let o of typeOptions" value="{{o}}">
                    {{o | translate: ['tmc.transport.register.leave.combined.weighingType.' + o,
                    translationService.language]}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>

        <div class="form-box" style="grid-column: 1 / span 2; grid-row: 3;">
          <h3>{{'hints' | translate: ['tmc.transport.register.leave.combined.checks.title',
            translationService.language]}}</h3>
          <div class="checks-list">
            <ul *ngIf="checksExist(transport)">
              <li class="check" *ngFor="let check of transport.checks">
                <div class="icon">
                  <i class="fa-light"
                    [ngClass]="{'fa-check color-ok': isOk(check), 'fa-exclamation-triangle color-warn': isWarning(check), 'fa-exclamation-circle color-error': isFailed(check)}"></i>
                </div>
                <div class="message">
                  {{check.nameDictionaryKey | translate: [check.nameDictionaryKey, translationService.language]}}
                  <ng-container *ngIf="descriptionExists(check)">
                    -
                    {{check.descriptionDictionaryKey | translate: [check.descriptionDictionaryKey,
                    translationService.language]}}
                  </ng-container>
                </div>
              </li>
            </ul>
            <span *ngIf="!checksExist(transport)">{{'Keine Hinweise' | translate:
              ['tmc.transport.register.leave.combined.checks.nochecks', translationService.language]}}</span>
          </div>
        </div>
      </div>

      <form *ngIf="allowExitDespiteOfRuleViolationEnabled" [formGroup]="allowExitDespiteOfRuleViolationFormGroup">
        <mat-checkbox formControlName="allowExitDespiteOfRuleViolation" name="allowExitDespiteOfRuleViolation">
          {{'allow leave despite of rule violations' | translate:
          ['tmc.transport.register.leave.combined.allow-exit-despite-of-rule-violations',
          translationService.language]}}
        </mat-checkbox>
      </form>

    </div>

    <i class="horizontal-divider"></i>
    <div class="messages"></div>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancel()">{{'cancel' | translate:
        ['tmc.transport.register.leave.combined.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button class="" (click)="decline()" [disabled]="isDeclineDisabled()">{{'decline' | translate:
        ['tmc.transport.register.leave.combined.action.decline', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="confirm-button" (click)="accept()" [disabled]="isAcceptDisabled">{{'accept' |
        translate: ['tmc.transport.register.leave.combined.action.accept', translationService.language]}}</button>
    </sc-actionbar>
  </div>